function AboutTwoDesktop({ item }) {
    return (
        <div className='w-full px-4 flex flex-col gap-1'>
            <h1 className='font-semibold text-[12px] leading-5 text-[#000000]'>{item.item.Heading}</h1>

            <p className='font-normal text-[8px] leading-[14px] text-[#666666]'>{item.item.Description}</p>
        </div>
    );
}

export default AboutTwoDesktop;
